import { connect } from 'react-redux'
import { submit, isSubmitting } from 'redux-form'

import { destroy as destroyGrid } from 'shared/LKGrid'

import { loadAvailableOfficerList } from '../../store/loanOfficer'

import { isLoading, getFormField } from './selectors'
import { fetchOfficers, officersFetched, officersFetchFailed, close } from './actions'
import { FORM_NAME, LKGRID_NAME } from './constants'

export default connect(
  (state) => ({
    manager: getFormField(state, 'ManagerID'),
    loading: isLoading(state),
    submitting: isSubmitting(FORM_NAME)(state),
  }),
  (
    dispatch,
    {
      match: {
        params: { ID, hash },
      },
    },
  ) => ({
    handleModalOpen: () => {
      dispatch(fetchOfficers({ LoanID: ID, HashSum_LoanID_: hash }))

      dispatch(loadAvailableOfficerList({ loanId: ID, loanHash: hash })).then((result) => {
        if (Array.isArray(result.payload)) {
          dispatch(officersFetched(result.payload))
        } else {
          dispatch(officersFetchFailed())
        }
      })
    },

    submit: () => {
      dispatch(submit(FORM_NAME))
    },

    close() {
      dispatch(destroyGrid(LKGRID_NAME))
      dispatch(close())
    },
  }),
)
